/* eslint-disable react/prop-types */
import { Tabs } from 'antd';

import styles from './SummaryTab.less';

const SummaryTab = ({ items, style }) => {
  return <Tabs defaultActiveKey="1" items={items} className={styles.container} style={style} />;
};

SummaryTab.propTypes = {};
SummaryTab.defaultProps = {};

export default SummaryTab;
